<div *ngIf="data" id="xdLol">
    <div [ngSwitch]="attributes.variant">
        <card-right-dynamic *ngSwitchCase="'card-right'" [data]="data" [form]="form"></card-right-dynamic>
        <card-top-dynamic *ngSwitchCase="'card-top'" [data]="data" [form]="form"></card-top-dynamic>
        <table-dynamic *ngSwitchCase="'table'" [data]="data" [form]="form"></table-dynamic>
        <table-form-dynamic *ngSwitchCase="'table-form'" [data]="data" [form]="form"></table-form-dynamic>
        <table-top-dynamic *ngSwitchCase="'table-top'" [data]="data" [form]="form"></table-top-dynamic>
        <table-top-hallazgos-dynamic *ngSwitchCase="'table-top-hallazgos'" [data]="data" [form]="form"></table-top-hallazgos-dynamic>
        <table-top-reply-dynamic *ngSwitchCase="'table-top-reply'" [data]="data" [form]="form"></table-top-reply-dynamic>
        <table-top-substances-dynamic *ngSwitchCase="'table-top-substances'" [data]="data" [form]="form"></table-top-substances-dynamic>
        <div *ngSwitchDefault>{{attributes.variant}}</div>
    </div>
</div>